import readXlsxFile, { type CellValue } from 'read-excel-file/browser';

export interface ParsedWorkbookSheet {
  name: string;
  rows: string[][];
}

function cellToString(value: CellValue | null): string {
  if (value === null) return '';
  if (value instanceof Date) return value.toISOString();
  return String(value);
}

export async function readWorkbookSheets(input: File | ArrayBuffer): Promise<ParsedWorkbookSheet[]> {
  const sheets = await readXlsxFile(input);
  return sheets.map(({ sheet, data }) => ({
    name: sheet,
    rows: data.map((row) => row.map(cellToString)),
  }));
}

export function rowsToCsv(rows: string[][]): string {
  return rows
    .map((row) => row.map((cell) => `"${cell.replace(/"/g, '""')}"`).join(','))
    .join('\n');
}
